'use client';
import { useSearchParams } from 'next/navigation';
import { useQuery } from '@tanstack/react-query';
import { useAccount, useEnsAddress } from 'wagmi';
import { QueryKey } from '../../queryKeys';
import { Address, Network } from 'nftx.js';
import { useNetwork } from '@nftx/react';

const ENS_NETWORKS = [Network.Mainnet];

// For some reason wagmi's useAccount doesn't work well with SSR
// (I think because it's always null on the server and always populated on the client)
// For some reason wrapping it in a useQuery call fixes it
const useAddress = () => {
  // Grab the debug address once and store it for the rest of the session
  const searchParams = useSearchParams();
  const user = searchParams.get('user') as Address;
  const network = useNetwork();

  const { data: debugAddress } = useQuery(
    [QueryKey.DEBUG_ADDRESS],
    () => {
      return user;
    },
    {
      staleTime: Infinity,
      refetchInterval: Infinity,
      cacheTime: Infinity,
      enabled: !!user,
    }
  );
  const { address } = useAccount();
  const { data: ensAddress } = useEnsAddress({
    name: debugAddress as string,
    enabled: !!(
      debugAddress &&
      !debugAddress.startsWith('0x') &&
      ENS_NETWORKS.includes(network)
    ),
  });

  const { data } = useQuery(
    [QueryKey.ADDRESS, address, ensAddress, debugAddress],
    () => {
      // Return null as undefined is not allowed in react-query v4
      return ensAddress || debugAddress || address || null;
    }
  );

  return data || undefined;
};

export default useAddress;
